import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'addSpace'
})
export class AddSpacePipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) return ''
    return value.replace(/([A-Z])/g, ' $1').trim()
  }
}
